export const allStatusKeyValues = {
  All: "all",
  "In Progress": "in_progress",
  "Action Required": "action_required",
  "Requested Follow Up": "requested_follow_up",
  Qualified: "qualified",
  Booked: "booked",
  "DNQ Criteria Not Met": "dnq_criteria_not_met",
  "DNQ Other": "dnq_other",
  "DNQ No Response": "dnq_no_response",
  "DNQ Not Interested": "dnq_not_interested",
  "Non-textable": "non-textable",
  "To-call": "to-call",
  "Contact Attempt 1": "contact_attempt_1",
  "Contact Attempt 2": "contact_attempt_2",
  "Contact Attempt 3": "contact_attempt_3",
  "Scheduled Screen": "scheduled_screen",
  Queued: "queued",
  Skipped: "skipped",
};

export function getKeyByValue(obj, value) {
  return Object.keys(obj).find((key) => obj[key] === value) || null;
}

export function getKeyOrValue(obj, input) {
  const latestObj = obj ? obj : allStatusKeyValues;
  // Check if the input exists as a value and return its key
  const key = Object.keys(latestObj).find((k) => latestObj[k] === input);
  if (key) return key;

  // Check if the input exists as a key and return its value
  if (latestObj.hasOwnProperty(input)) return latestObj[input];

  // Return null if not found
  return null;
}

export function createStatusObjects(statusArray) {
  return statusArray.reduce((acc, status) => {
    const key = status;
    const value = status.toLowerCase().replace(/\s+/g, "_");
    acc[key] = value;
    return acc;
  }, {});
}

export const getStatusID = (statusName, statusList) => {
  const status = statusList.find((item) => item.statusName === statusName);
  return status ? status.statusID : null;
};

export function getInitials(name) {
  return name
    .split(" ")                // Split by spaces
    .slice(0, 2)               // Take only the first two words
    .map((part) => part[0]?.toUpperCase()) // Get the first letter and capitalize
    .join("");                 // Join to form initials
}

export function transcateText(str, maxLength) {
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength) + "...";
}
